import { render, staticRenderFns } from "./SearchSomething.vue?vue&type=template&id=3bc3ec4a&scoped=true&"
import script from "./SearchSomething.vue?vue&type=script&lang=js&"
export * from "./SearchSomething.vue?vue&type=script&lang=js&"
import style0 from "./SearchSomething.vue?vue&type=style&index=0&id=3bc3ec4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc3ec4a",
  null
  
)

export default component.exports